import { Routes } from "@angular/router";
import { HomePage } from "./home.page";

export const routes: Routes = [
  {
    path: "home",
    component: HomePage,
    children: [
      {
        path: "tab0",
        loadComponent: () =>
          import("../tab0/tab0.page").then((m) => m.Tab0Page),
      },
      {
        path: "tab1",
        loadComponent: () =>
          import("../tab1/tab1.page").then((m) => m.Tab1Page),
      },
      {
        path: "tab2",
        loadComponent: () =>
          import("../tab2/tab2.page").then((m) => m.Tab2Page),
      },
      {
        path: "tab3",
        loadComponent: () =>
          import("../tab3/tab3.page").then((m) => m.Tab3Page),
      },
      {
        path: "tab4",
        loadComponent: () =>
          import("../tab4/tab4.page").then((m) => m.Tab4Page),
      },
      {
        path: "",
        redirectTo: "/home/tab0",
        pathMatch: "full",
      },
    ],
  },
  {
    path: "student-detail",
    loadComponent: () =>
      import(
        "../students/containers/student-detail-page/student-detail.component"
      ).then((m) => m.StudentDetailComponent),
  },
  {
    path: "archived-students",
    loadComponent: () =>
      import(
        "../students/containers/archived-student-list-page/archived-student-list-page.component"
      ).then((m) => m.ArchivedStudentListPageComponent),
  },
  {
    path: "student-selection",
    loadComponent: () =>
      import("../students/containers/student-list-page/students.page").then(
        (m) => m.StudentsPage
      ),
  },
  {
    path: "lesson-detail",
    loadComponent: () =>
      import(
        "../lessons/containers/lesson-detail-page/lesson-detail.component"
      ).then((m) => m.LessonDetailComponent),
  },
  {
    path: "past-lessons",
    loadComponent: () =>
      import(
        "../lessons/containers/past-lesson-list-page/past-lessons.page"
      ).then((m) => m.PastLessonsPage),
  },
  {
    path: "invoice-detail",
    loadComponent: () =>
      import(
        "../office/containers/invoice-detail-page/invoice-detail-page.component"
      ).then((m) => m.InvoiceDetailPageComponent),
  },
  {
    path: "payment-detail",
    loadComponent: () =>
      import(
        "../office/containers/payment-detail-page/payment-detail-page.component"
      ).then((m) => m.PaymentDetailPageComponent),
  },
  {
    path: "open-invoice-list",
    loadComponent: () =>
      import(
        "../office/containers/open-invoice-list-page/open-invoice-list-page.component"
      ).then((m) => m.OpenInvoiceListPageComponent),
  },
  {
    path: "lessons",
    loadComponent: () =>
      import(
        "../settings/containers/lessons-setting/lessons-setting.component"
      ).then((m) => m.LessonsSettingComponent),
  },
  {
    path: "payments",
    loadComponent: () =>
      import(
        "../settings/containers/payment-setting/payment-setting/payment-setting.component"
      ).then((m) => m.PaymentSettingComponent),
  },
  {
    path: "calendar",
    loadComponent: () =>
      import(
        "../settings/containers/calendar-setting/calendar-setting.component"
      ).then((m) => m.CalendarsSettingComponent),
  },
  {
    path: "education",
    loadComponent: () =>
      import(
        "../settings/containers/education/education-setting/education-setting.component"
      ).then((m) => m.EducationSettingComponent),
  },
  {
    path: "company",
    loadComponent: () =>
      import(
        "../settings/containers/company-setting/company-setting.component"
      ).then((m) => m.CompanySettingComponent),
  },
  {
    path: "preferences",
    loadComponent: () =>
      import(
        "../settings/containers/preferences-setting/preferences-setting.component"
      ).then((m) => m.PreferencesSettingComponent)
  },
  {
    path: "pro-subscription",
    loadComponent: () =>
      import(
        "../settings/containers/pro-subscription-setting/pro-subscription-setting.component"
      ).then((m) => m.ProSubscriptionSettingComponent)
  },
  {
    path: "education-category-detail",
    loadComponent: () =>
      import(
        "../settings/containers/education/education-category-detail/education-category-detail.component"
      ).then((m) => m.EducationCategoryDetailComponent),
  },
  {
    path: "education-title",
    loadComponent: () =>
      import(
        "../settings/containers/education/education-body/education-body.component"
      ).then((m) => m.EducationBodyComponent),
  },
  {
    path: 'reports',
    loadComponent: () =>
      import(
        "../report-generation/containers/report-list/report-list.component"
      ).then((m) => m.ReportListComponent),
  },
  {
    path: 'products',
    loadComponent: () =>
      import(
        "../products/containers/product-list/product-list.component"
      ).then((m) => m.ProductListComponent),
  },
  {
    path: 'support-info',
    loadComponent: () =>
      import(
        "../settings/containers/support-info/support-info.component"
      ).then((m) => m.SupportInfoComponent),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import(
        "../auth/containers/auth-reset-password/auth-reset-password.component"
      ).then((m) => m.AuthResetPasswordComponent),
  },
  {
    path: "",
    redirectTo: "/home/tab0",
    pathMatch: "full",
  },
];
